// Module
var code = "<md-menu> <md-button class=\"md-icon-button\" ng-click=\"::$mdMenu.open($event)\"> <md-icon class=\"tmr-icon-24 o-question-help-1 md-accent md-hue-1\"></md-icon> </md-button> <md-menu-content> <div ng-include=\"::$ctrl.content\"></div> </md-menu-content> </md-menu> ";
// Exports
var _module_exports =code;;
var path = 'components/menus/helpMenu/helpMenu.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;